module.exports = __webpack_public_path__ + "assets/vuejs.c8490286.svg";